import getConfig from 'next/config';
import { useEffect, useState } from 'react';
import EirActionModal from '../eir-action-modal/EirActionModal';
import fetchInfo from '../../../util/fetchModalData';
import { setJourneyPicker } from './journeyPicker.util';

const { publicRuntimeConfig } = getConfig();
const EirJourneyPickerModal = ({
  openJourneyPicker,
  openKeepNumberCheck,
  graphql,
  customerEligibility,
  setShowSubscriptionModal,
  isStandaloneHandset,
  crossSellHandsetJourney,
  coMobileSubscriptions,
  changeOfferJourney,
  setHidePortAccordian,
}) => {
  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);
  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'mw-eir-action-modals-tailor-exp',
      });
      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getCmsData();
  }, []);

  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID}
      open={openJourneyPicker.value}
      handleClose={openJourneyPicker.disable}
      iconSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.url}`}
      title={`Hi ${customerEligibility?.contactDetails?.firstName},${
        cmsCollectionData?.attributes?.title ? cmsCollectionData?.attributes?.title : ''
      }`}
      description={`${
        cmsCollectionData?.attributes?.firstHalfDescription
          ? cmsCollectionData?.attributes?.firstHalfDescription
          : ''
      }
      ${
        cmsCollectionData?.attributes?.secondHalfDescription
          ? cmsCollectionData?.attributes?.secondHalfDescription
          : ''
      }
      `} // will remove hardcoded discount once to get to know where to get data
      cta={[
        {
          // text: 'Upgrade your mobile',
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : 'Upgrade your mobile',
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
          type: 'contained',
          action: () =>
            setJourneyPicker({
              openJourneyPicker,
              journey: 'change_offer',
              setShowSubscriptionModal,
              coMobileSubscriptions,
              changeOfferJourney,
              setHidePortAccordian,
              isStandaloneHandset,
            }),
        },
        {
          // text: 'Add a new mobile',
          text: cmsCollectionData?.attributes?.cta[1]?.name
            ? cmsCollectionData?.attributes?.cta[1]?.name
            : 'Add a new mobile',
          ariaLabel: cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            : '',
          type: 'contained',
          action: () =>
            setJourneyPicker({
              graphql,
              openJourneyPicker,
              openKeepNumberCheck,
              customerEligibility,
              journey: 'cross_sell',
              isStandaloneHandset,
              crossSellHandsetJourney,
            }),
        },
      ]}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      disablecta={false}
      load={load}
    />
  );
};
export default EirJourneyPickerModal;
